var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlasticSurgeryQuestionCategory = function SvgPlasticSurgeryQuestionCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#plastic-surgery-question-category_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#plastic-surgery-question-category_svg__b)",
    d: "m37.619 14.626-.258-.158c-1.76-1.086-4.739-2.931-6.067-3.83-.631-.427-1.183-.967-1.98-.967-.602 0-1.142.241-1.58.63 0 0-.035.033-.094.074a.74.74 0 0 1-.405.141q-.028 0-.054-.004-.023-.001-.044-.004a.8.8 0 0 1-.367-.19l-.026-.023-.01-.01c-.435-.379-1.145-.613-1.74-.613-.794 0-1.311.366-1.955.884-1.22.981-4.25 2.878-6.003 3.949l-.05.03c-.509.31-.853.889-.853 1.552q.001.294.086.562.074.175.151.349c2 4.438 6.113 7.485 10.865 7.485s8.893-3.064 10.888-7.523l.107-.25c.068-.194.107-.403.107-.622 0-.602-.284-1.136-.719-1.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#plastic-surgery-question-category_svg__c)",
    d: "M22.191 21.819c-1.24-2.266-4.493-2.266-5.734 0L10.07 33.493c-1.192 2.178.384 4.836 2.867 4.836h12.774c2.482 0 4.059-2.658 2.867-4.836z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "plastic-surgery-question-category_svg__b",
    x1: 20.309,
    x2: 34.235,
    y1: 10.853,
    y2: 26.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8C85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1493E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plastic-surgery-question-category_svg__c",
    x1: 12.774,
    x2: 25.963,
    y1: 21.99,
    y2: 33.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC42E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "plastic-surgery-question-category_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgPlasticSurgeryQuestionCategory;